export const calculateStats = (content) => {
  // Palabras
  const words = content.trim() === '' ? 0 : 
    content.trim().split(/\s+/).filter(word => word.length > 0).length;

  // Caracteres con espacios
  const characters = content.length;

  // Caracteres sin espacios
  const charactersNoSpaces = content.replace(/\s/g, '').length;

  // Líneas
  const lines = content === '' ? 0 : content.split('\n').length;

  // Oraciones (aproximado)
  const sentences = content === '' ? 0 : 
    content.split(/[.!?]+/).filter(s => s.trim().length > 0).length;

  // Párrafos
  const paragraphs = content === '' ? 0 :
    content.split(/\n\s*\n/).filter(p => p.trim().length > 0).length;

  return {
    words,
    characters,
    charactersNoSpaces,
    lines,
    sentences,
    paragraphs
  };
};

export const getReadingTime = (words) => {
  const wordsPerMinute = 200;
  return Math.ceil(words / wordsPerMinute) || 0;
};

export const getAverageCharsPerWord = (characters, words) => {
  return words > 0 ? (characters / words).toFixed(1) : '0';
};